export function liteRedirect(path: string) {
  console.log(`liteRedirect to ${path}`);
  const queryString = new URLSearchParams(window.location.search);
  queryString.set("lite", "1");
  window.location.href = `/${path}?${queryString}`;
}
